<div class="container-fluid dashboard">
  <div class="row mt-4">
    <div class="col-12">
      <div class="card">
        <div class="card-body">
          <div class="text-center py-5">
            <h2 class="mb-2">Welcome to {{ appName }}<ng-container *ngIf="displayName">, {{ displayName }}</ng-container></h2>
            <p class="text-muted mb-4">Use the menu to manage licences and roles.</p>
            <p class="mb-1" *ngIf="currentUser?.emailAddress">
              <strong>Email:</strong> {{ currentUser?.emailAddress }}
            </p>
            <p class="mb-0" *ngIf="currentUser?.isSuperAdmin">
              <span class="badge bg-primary">Super Admin</span>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
